import React from 'react';
import CTSUErrorBoundary from 'components/ErrorBoundary';

const RenderElement = ({
  children, access
}) => {
  if (access === true) {
    return (
      <CTSUErrorBoundary>
        {children}
      </CTSUErrorBoundary>
    );
  }
  return null;
};


export { RenderElement };
